export default __webpack_public_path__ + "static/media/pot3.664a580d.jpg";